import { render, staticRenderFns } from "./TheSelectLocale.component.vue?vue&type=template&id=97ebd084"
import script from "./TheSelectLocale.component.vue?vue&type=script&lang=js"
export * from "./TheSelectLocale.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports